import { render, staticRenderFns } from "./InfoHomeComponent.vue?vue&type=template&id=4a1cdad8&scoped=true"
import script from "./InfoHomeComponent.vue?vue&type=script&lang=js"
export * from "./InfoHomeComponent.vue?vue&type=script&lang=js"
import style0 from "./InfoHomeComponent.vue?vue&type=style&index=0&id=4a1cdad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1cdad8",
  null
  
)

export default component.exports